module.exports = __webpack_public_path__ + "ccd4807e90bc12a3ad8b8749b860019d.jpg";